/* vuex状态管理器 */
import { createStore } from "vuex";
const store = createStore({
  // state, 状态
  // mutations, 同步修改状态的函数
  // actions, 异步修改状态函数
  // getters, 处理数据
  state: {
    resName: "cc咖啡馆",
  },
  mutations: {
    setResName: (state, payload) => {
      // sate对象就对应了sate.js中的对象
      // payload载荷 对应的 传递的 josn对象参数(name:zs,age:12)
      state.resName = payload.resName;
    },
    setName: (state, payload) => {
      state.Name = payload.Name;
    },
  },
  actions: {
    setResNameAsync: (context, payload) => {
      // 异步修改值 在异步方法中调用了同步方法
      //  context指的是Vuex的上下文，相当于 this.$store
      // 死代码，6秒后执行
      setTimeout(function () {
        context.commit("setResName", payload);
      }, 6000);
    },
  },
  getters: {
    getResName: (state) => {
      /* 这里的sate代表的是sate.js整个文件 */
      return state.resName;
    },
  },
});
export default store;
